



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class StepFullName extends Vue {
  @Prop({required: false, type: String}) categorySrc !: string
  @Prop({required: false, type: String}) name !: string
}
